import { Variants } from 'framer-motion'
import { theme } from 'styles/theme'

export const containerVariants: Variants = {
  hidden: {},
  enter: {
    transition: {
      staggerChildren: 0.1,
    },
  },
  leave: {
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const variants: Variants = {
  hidden: {
    opacity: 0,
    translateY: '3rem',
  },
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      type: 'tween',
      ease: theme.easeValues.out,
      duration: 0.5,
    },
  },
  leave: {
    opacity: 0,
    translateY: '-1rem',
    transition: {
      type: 'tween',
      ease: theme.easeValues.in,
    },
  },
}
